<!--  -->
<template>
  <div class="visa-wrapper">
    <div class="visa-head">
      <div style="display: flex;align-items: center;gap: 5px;">
        <img src="../../../assets/images/visa/collect-index.png" alt="" style="width: 21px;height: 21px;">
        <span style="font-weight: 600;color: #000;font-size: 22px;">热门&常用服务</span>
      </div>
      <!-- 常用国家选择 -->
      <div class="country_list">
        <div class="country_item" v-for="item in topCountryList" @click="handleSearch(item.name)">
          <img class="country_item_img" :src="item.images" alt="">
          <span>{{ item.name }}</span>
        </div>
      </div>
      <!-- 筛选数据 -->
      <div class="country_filter">
        <div style="display: flex;align-items: center;justify-content: space-between;gap: 20px;">
          <div class="country_filter_item" @click="handleFilterChange(item.value, true)"
            :class="topFilterListActive == item.value ? 'active' : ''" v-for="item in finalTags">
            {{ item.name }}
          </div>
          <el-input style="width: 300px;" placeholder="搜索国家" prefix-icon="el-icon-search" @input="handleInputDebounce"
            clearable v-model="searchContent">
          </el-input>
        </div>
        <!-- 下载按钮 -->
        <el-button style="
                  height: 38px;
                  font-size: 17px;
                  border-radius: 4px;
                  background-color: #3888e9;
                  color: #ffffff;
                " @click="downloadPriceList">下载价目表</el-button>
      </div>
    </div>
    <div class="wrap" v-loading="loading">
      <el-card class="box-card" v-for="(item, index) in filteredGoodsList" :key="item.id">
        <div class="top">
          <img class="bgc" :src="item.nationalFlagImg" />
          <div>
            <p>{{ item.productName + item.type + item.typeDesc }}</p>
          <p style="font-size: 10px;color: #409EFF;" v-if="item.isKMPay">签证费：{{ item.visaFee }}{{item.exchangeRateName}}&nbsp;&nbsp;人民币：{{ item.chnPrice }}元</p>
          </div>
        </div>
        <div style="width: 100%; display: inline-flex;justify-content: space-between;margin-bottom: 10px;">
          <span v-if="item.isPackage">平台代付：
            <span style="color: #f8912c;"> {{ item.packPrice }} <i class="el-icon-coin"></i> </span>
          </span>
          <span v-if="item.isTickets">普通支付：
            <span style="color: #f8912c;"> {{ item.tickets }} <i class="el-icon-coin"></i> </span>
          </span>
        </div>
        <div class="center">
          <p v-if="item.systemVisaId == 2" @click="openDialog(item)">支付方式设置</p>
          <p v-if="false">行程设置</p>
          <p v-if="false">基础设置</p>
          <p v-if="item.tutorialUrl" @click="openUrl(item.tutorialUrl)">
            使用说明
          </p>
          <p v-if="item.collectConfig" @click="openConfigDialog(item)">
            {{ JSON.parse(item.collectConfig).windowName }}
          </p>
          <p v-if="false">高危人群告知</p>
          <p v-if="false">送签信息</p>
        </div>
        <div class="bottom">
          <div class="icon-box">
            <div class="icon" @click="isCollected(item, index)">
              <img :src="item.isCollected
                ? require('../../../assets/images/visa/collect-on.png')
                : require('../../../assets/images/visa/collect-off.png')
                " alt="收藏" />
            </div>
          </div>
          <p class="btn" @click="toOrderCenter(item.countryId)">订单列表</p>
          <p class="btn">
            <el-button :loading="item.loading" @click="toOrder(item, index)" style="
                  width: 110px;
                  height: 38px;
                  font-size: 17px;
                  border-radius: 4px;
                  background-color: #3888e9;
                  color: #ffffff;
                ">立即办理</el-button>
          </p>
        </div>
      </el-card>
      <el-dialog :visible.sync="dialogTableVisible" width="60%" class="common-dialog-class">
        <div class="dialog-member-wrap">
          <div class="dialog-member-title">
            <span class="dialog-member-name">银行卡管理</span>
            <div class="dialog-close" @click="dialogTableVisible = false">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <div class="dialog-form-wrap">
            <div>
              <el-button size="small" @click="addBankCard"
                style="background-color: #3888e9;color: #fff;border-radius: 4px;margin-bottom: 16px;">新增银行卡</el-button>
              <el-table :data="bankCardList" :header-cell-style="{
                backgroundColor: '#F2F4F7',
                color: '#333',
                fontWeight: 'bold',
                textAlign: 'center',
                fontSize: '12px',
              }" style="width: 100%" :cell-style="{ 'text-align': 'center' }">
                <el-table-column property="type" label="种类"></el-table-column>
                <el-table-column property="cardNumber" label="卡号"></el-table-column>
                <el-table-column label="持卡人姓名">
                  <template slot-scope="scope">
                    <div>{{ scope.row.surName + "" + scope.row.name }}</div>
                  </template>
                </el-table-column>
                <el-table-column property="validity" label="有效期">
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.validity | format }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column property="cvv" label="CVN/CVC2"></el-table-column>
                <el-table-column property="remarks" label="备注"></el-table-column>
                <el-table-column label="操作" header-align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="addDialog" width="40%" class="common-dialog-class">
        <div class="dialog-member-wrap">
          <div class="dialog-member-title">
            <span class="dialog-member-name">{{ formData.id ? '编辑银行卡' : '添加银行卡' }}</span>
            <div class="dialog-close" @click="addDialog = false">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <div class="dialog-form-wrap">
            <div>
              <el-form label-width="auto" :inline="true" :rules="rules" :model="formData" class="info-form"
                ref="ruleForm">
                <el-form-item label="卡类型" class="radio-item">
                  <el-radio-group v-model="formData.type" size="small" class="radio-group" text-color="#3888e9"
                    fill="#3888e9">
                    <el-radio class="radio-group-item" label="002" border><img style="width: 28px;height: 28px;"
                        src="https://file.sport-syy.com/visa/2024/01/09/1704787427007.png" /></el-radio>
                    <el-radio class="radio-group-item" label="001" border><img style="width: 28px;height: 28px;"
                        src="https://file.sport-syy.com/visa/2024/01/09/1704787451136.png" /></el-radio>
                    <el-radio class="radio-group-item" label="007" border><img style="width: 28px;height: 28px;"
                        src="https://file.sport-syy.com/visa/2024/01/09/1704787465874.png" /></el-radio>
                    <el-radio class="radio-group-item" label="003" border><img style="width: 28px;height: 28px;"
                        src="https://file.sport-syy.com/visa/2024/01/09/1704787478079.png" /></el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="是否默认支付卡">
                  <el-switch active-color="#3888e9" v-model="formData.isDefault"></el-switch>
                </el-form-item>
                <el-form-item label="卡号" prop="cardNumber" style="width:100%">
                  <el-input v-model="formData.cardNumber" placeholder="请输入卡号" clearable style="width:600px"></el-input>
                </el-form-item>
                <el-form-item label="持卡人姓" prop="surName">
                  <el-input v-model="formData.surName" placeholder="请输入姓" @blur="toUpperCase('surName')"
                    clearable></el-input>
                </el-form-item>
                <el-form-item label="持卡人名" prop="name">
                  <el-input v-model="formData.name" placeholder="请输入名" @blur="toUpperCase('name')" clearable></el-input>
                </el-form-item>
                <el-form-item label="有效期" prop="validity">
                  <el-date-picker v-model="formData.validity" type="month" placeholder="请选择年和月">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="CVV/CVC2" prop="cvv">
                  <el-input-number :controls="false" v-model="formData.cvv" placeholder="请输入"></el-input-number>
                </el-form-item>
                <el-form-item label="国家" prop="country">
                  <el-select v-model="formData.country" filterable placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="城市" prop="city">
                  <el-input v-model="formData.city" placeholder="请输入城市" clearable></el-input>
                </el-form-item>
                <el-form-item label="地址" prop="address" style="width:100%">
                  <el-input v-model="formData.address" placeholder="请输入地址" clearable style="width:600px"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remarks" style="width:100%">
                  <el-input v-model="formData.remarks" placeholder="请输入备注" clearable style="width:600px"></el-input>
                </el-form-item>
                <el-form-item style="width:100%;text-align: right;">
                  <el-button size="medium" @click="addDialog = false">取消</el-button>
                  <el-button size="medium" @click="submit('ruleForm')" :loading="formLoading"
                    style="background-color: #3888e9;color: #fff;border-radius: 4px">确认</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog :title="currentItem.collectConfig?.windowName || '配置账户'" :visible.sync="configDialog" width="500px">
        <el-form :model="dynamicFormModel" ref="configFormRef" :rules="dynamicFormRules" label-width="120px">
          <el-form-item v-for="item in (currentConfig.dataConfig || [])" :key="item.valueName"
            :label="item.valueZhName" :prop="item.valueName">
            <el-input v-model="dynamicFormModel[item.valueName]" :type="item.type === '1' ? 'text' : 'password'"
              :placeholder="`请输入${item.valueZhName}`" clearable></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitConfigForm">确认</el-button>
          <el-button @click="closeConfigDialog">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getordertools, toolcollect, orgorder, querybankcards, addbankcard, updatebankcard, delbankcard } from "@/api/settings";
import { Json } from "@/assets/js/visa.js";
import aodaliya from "@/assets/images/visa/aodaliya.png"
import eluosi from "@/assets/images/visa/eluosi.png"
import faguo from "@/assets/images/visa/faguo.png"
import hanguo from "@/assets/images/visa/hanguo.png"
import meiguo from "@/assets/images/visa/meiguo.png"
import yidali from "@/assets/images/visa/yidali.png"
import yindunixiya from "@/assets/images/visa/yindunixiya.png"
import yingguo from "@/assets/images/visa/yingguo.png"
import xinxilan from "@/assets/images/visa/xinxilan.png"
import malaixiya from "@/assets/images/visa/malaixiya.png"
import taiguo from "@/assets/images/visa/taiguo.png"
import wenlai from "@/assets/images/visa/wenlai.png"
import bajisitan from "@/assets/images/visa/bajisitan.png"
import jianpuzhai from "@/assets/images/visa/jianpuzhai.png"
import laowo from "@/assets/images/visa/laowo.png"
import maerdaifu from "@/assets/images/visa/maerdaifu.png"
import niboer from "@/assets/images/visa/niboer.png"
import riben from "@/assets/images/visa/riben.png"
import sililanka from "@/assets/images/visa/sililanka.png"
import tuerqi from "@/assets/images/visa/tuerqi.png"
import yuenan from "@/assets/images/visa/yuenan.png"
import jierjisisitan from "@/assets/images/visa/jierjisisitan.png"
import request from "@/utils/request";
import * as XLSX from 'xlsx'
import _ from "lodash";
import { getVisaType } from "@/views/settings/components/visaType";
import { saveotherconfig } from "@/api/order";
export default {
  name: "visa",
  components: {},
  data() {
    var checkCardNumber = (rule, value, callback) => {
      if (!/^\d+$/.test(value)) {
        return callback(new Error("卡号必须为数字"));
      } else {
        callback();
      }
      if (value.length < 1 || value.length > 20) {
        return callback(new Error("请输入1-20位数字"));
      } else {
        callback();
      }
    };
    var checkSurName = (rule, value, callback) => {
      if (!/^[a-zA-Z]{1,40}$/.test(value)) {
        return callback(new Error("请输入1-40个字符,必须为纯字母格式"));
      } else {
        callback();
      }
    };
    var checkCvv = (rule, value, callback) => {
      let str = value.toString();
      if (!/^\d+$/.test(str) || str.length > 4) {
        return callback(new Error("支持最大4位数字"));
      } else {
        callback();
      }
    }
    var checkCity = (rule, value, callback) => {
      const pattern = /^[a-zA-Z0-9\s]+$/;
      if (!pattern.test(value)) {
        return callback(new Error("仅支持英文大小写、数字、空格"));
      } else {
        callback();
      }
    }
    var checkAddress = (rule, value, callback) => {
      const pattern = /^[a-zA-Z0-9@\(\){}\-_\\,./"']*\s*[a-zA-Z0-9@\(\){}\-_\\,./"']*\s*$/;
      if (!pattern.test(value) || value.length > 200) {
        return callback(new Error(`仅支持英文大小写、数字、空格，符号@ () - _ {}  ' " , . / 且长度在1-200个字符`));
      } else {
        callback();
      }
    }
    return {
      currentConfig: {},
      configDialog: false,
      currentItem: {},
      configFormRef: {},
      dynamicFormModel: {},
      //国家签证列表
      countryList: [],
      addH: false,
      loading: false,
      dialogTableVisible: false,
      bankCardList: [],
      addDialog: false,
      formData: {
        type: "002",
        validity: '',
        country: "CHN"
      },
      configRules: {
        configUser: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        configPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      rules: {
        cardNumber: [
          { required: true, message: '请输入卡号', trigger: 'blur' },
          { validator: checkCardNumber, trigger: ['blur', 'change'] }
        ],
        surName: [
          { required: true, message: '请输入姓', trigger: 'blur' },
          { validator: checkSurName, trigger: ['blur', 'change'] }
        ],
        name: [
          { required: true, message: '请输入名', trigger: 'blur' },
          { validator: checkSurName, trigger: ['blur', 'change'] }
        ],
        validity: [
          { required: true, message: '请选择年和月', trigger: 'blur' },
        ],
        cvv: [
          { required: true, message: '请输入CVV/CVC2', trigger: 'blur' },
          { validator: checkCvv, trigger: 'blur' }
        ],
        country: [
          { required: true, message: '请选择国家', trigger: 'blur' },
        ],
        city: [
          { required: true, message: '请输入城市', trigger: 'blur' },
          { validator: checkCity, trigger: ['blur', 'change'] }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' },
          { validator: checkAddress, trigger: ['blur', 'change'] }
        ],
        remarks: [
          { max: 100, message: '请输入1-100个字符', trigger: ['blur', 'change'] }
        ],
      },
      options: [],
      systemVisaId: 0,//识别哪个国家的支付
      formLoading: false,
      topCountryList: [
        {
          name: '美国',
          images: meiguo,
          value: ''
        },
        {
          name: '越南',
          images: yuenan,
          value: ''
        },
        {
          name: '印尼',
          images: yindunixiya,
          value: ''
        },
        {
          name: '韩国',
          images: hanguo,
          value: ''
        },
        {
          name: '新西兰',
          images: xinxilan,
          value: ''
        },
        {
          name: '马来西亚',
          images: malaixiya,
          value: ''
        },
        {
          name: '泰国',
          images: taiguo,
          value: ''
        },
        {
          name: '文莱',
          images: wenlai,
          value: ''
        },
        {
          name: '巴基斯坦',
          images: bajisitan,
          value: ''
        },
        {
          name: '柬埔寨',
          images: jianpuzhai,
          value: ''
        },
        {
          name: '老挝',
          images: laowo,
          value: ''
        },
        {
          name: '马尔代夫',
          images: maerdaifu,
          value: ''
        },
        {
          name: '尼泊尔',
          images: niboer,
          value: ''
        },
        {
          name: '日本',
          images: riben,
          value: ''
        },
        {
          name: '斯里兰卡',
          images: sililanka,
          value: ''
        },
        {
          name: '土耳其',
          images: tuerqi,
          value: ''
        },
        {
          name: '吉尔吉斯',
          images: jierjisisitan,
          value: ''
        },
      ],
      topFilterList: [
        {
          name: '全部',
          value: -1
        },
        {
          name: '亚洲',
          value: 0
        },

        {
          name: '美洲',
          value: 3
        },
      ],
      topFilterListActive: -1,
      searchContent: '',
      isFirst: true,
      isHandleCollet: false,
    };
  },
  created() {
    this.getordertool();
  },
  mounted() {

    this.getbankcards();
    this.options = Json.stateList;
  },
  computed: {
    // 1. 提取全局所有已收藏的商品（isCollected为true）
    collectedGoodsList() {
      return this.countryList.filter(goods => goods.isCollected === true);
    },
    // 2. 最终展示的标签列表（动态添加「我的收藏」在最前面）
    finalTags() {
      // 核心判断：是否有收藏商品（有则显示「我的收藏」，无则隐藏）
      const hasCollected = this.collectedGoodsList.length > 0;

      if (hasCollected) {
        // 有收藏：「我的收藏」 + 基础地区标签
        return [{
          name: '我的收藏',
          value: -100
        }, ...this.topFilterList];
      } else {
        // 无收藏：直接返回基础地区标签
        // 如果筛选标签在我的收藏中则切换到全部
        if (this.topFilterListActive == -100) {
          this.topFilterListActive = -1;
        }
        return this.topFilterList;
      }
    },

    // 3. 最终渲染的商品列表（根据当前选中标签筛选）
    filteredGoodsList() {
      const { topFilterListActive, countryList } = this;
      const newCountryList = countryList.map(t => {
        t.chnPrice = parseFloat(t.visaFee*t.rate).toFixed(2);
        return {
          ...t,
        }
      });
      console.log(topFilterListActive, 123)
      // 场景A：选中「我的收藏」→ 直接返回所有收藏商品
      if (topFilterListActive === -100) {
        return [...this.collectedGoodsList];
      }

      // 场景B：选中地区标签（全部/亚洲/美洲）→ 先筛选地区
      let regionFilteredList = [];
      if (topFilterListActive === -1) {
        // 选中「全部」→ 返回完整原始列表
        regionFilteredList = [...newCountryList];
      } else {
        // 选中「亚洲/美洲」→ 筛选对应地区的商品
        regionFilteredList = [...newCountryList];
      }

      // 场景B补充：无论地区筛选结果是否为空，都直接返回（满足「非全部标签筛选为空不删除我的收藏标签」）
      return [...regionFilteredList];
    },

    // 动态生成表单规则
    dynamicFormRules() {
      const rules = {};
      const currentConfig = this.currentItem.collectConfig ? JSON.parse(this.currentItem.collectConfig) : {};
      
      if (currentConfig && currentConfig.dataConfig) {
        currentConfig.dataConfig.forEach(item => {
          if (item.need == 'true') {
            const fieldRules = [{ required: true, message: `请输入${item.valueZhName}`, trigger: 'change' }];
            
            // 根据type添加不同的校验规则
            if (item.type == '1') {
              // 校验邮箱格式
              fieldRules.push({
                type: 'email',
                message: `请输入正确的${item.valueZhName}`,
                trigger: 'change'
              });
            } else if (item.type == '2') {
              // 校验手机号格式
              fieldRules.push({
                pattern: /^1[3-9]\d{9}$/,
                message: `请输入正确的${item.valueZhName}`,
                trigger: 'change'
              });
            } else if (item.type == '3') {
              // 校验纯数字
              fieldRules.push({
                pattern: /^\d+$/,
                message: `${item.valueZhName}必须是纯数字`,
                trigger: 'change'
              });
            }
            // type=0 只进行必填校验，不进行格式校验
            
            rules[item.valueName] = fieldRules;
          }
        });
      }
      return rules;
    }

  },
  filters: {
    format(value) {
      return value.split(' ')[0];
    }
  },
  //方法集合
  methods: {
    openConfigDialog(item) {
      this.configDialog = true;
      this.currentItem = item;
      this.dynamicFormModel = {};
      this.currentConfig=item.collectConfig  ? JSON.parse(item.collectConfig) : {};
      const currentConfig = {
        ...this.currentConfig
      }
      if (currentConfig && currentConfig.dataConfig) {
        currentConfig.dataConfig.forEach(field => {
          // 使用this.$set确保属性是响应式的
          this.$set(this.dynamicFormModel, field.valueName, field.valueName || '');
        });
      }
    },

    closeConfigDialog() {
      this.configDialog = false;
      this.currentItem = {};
    },
    // 配置账户提交
    submitConfigForm() {
      this.$refs.configFormRef.validate((valid) => {
        if (valid) {
          const currentConfig = this.currentItem.collectConfig ? JSON.parse(this.currentItem.collectConfig) : {};
          if (currentConfig && currentConfig.dataConfig) {
            const data = currentConfig.dataConfig.map(item => {
              return {
                ...item, // 保留原来所有字段（type/need等不变）
                // 把用户输入的新值 赋值给 valueName（后端要的格式）
                valueName: this.dynamicFormModel[item.valueName]
              }
            })
            saveotherconfig({
              systemVisaId: this.currentItem.systemVisaId,
              dataConfig: 
              JSON.stringify(this.dynamicFormModel)
            }).then(res => {
              if (res.code == 1) {
                this.$message({
                  message: '配置成功',
                  type: 'success'
                })
                this.closeConfigDialog();
                this.getordertool();
              }
            })
          }
        }
      })
    },
    downloadPriceList() {
      request("/org_api/v1/org/getordertoolprice", {
        method: 'get',
        params: {}
      }).then(res => {
        const data = res.data

        // 只保留你要的字段
        const exportData = data.map(item => ({
          "产品名称": item.productName,
          "签证费用": item.visaFee,
          "递交费用": item.tickets
        }))

        // 生成 Excel
        const ws = XLSX.utils.json_to_sheet(exportData)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, "价目表")

        // 🔥 关键：直接下载，不要 return 或 console
        XLSX.writeFile(wb, "价目表.xlsx")
      })
    },
    handleInputDebounce: _.debounce(function (e) {
      this.handleSearch(e) // 注意this指向，这里不能用箭头函数
    }, 500),
    handleSearch(val) {
      this.searchContent = val;
      this.getordertool();
    },
    handleFilterChange(value, type = false) {
      if (value == -100) {

      }
      if (value == this.topFilterListActive) return
      this.topFilterListActive = value;
      this.getordertool();
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true;
          if (this.formData.id) {
            updatebankcard({ ...this.formData }).then((res) => {
              if (res.code == 1) {
                this.$message({
                  message: '更新成功',
                  type: 'success'
                })
                this.formLoading = false;
                this.addDialog = false;
                this.getbankcards();
              }
            }).catch((err) => {
              console.log(err)
              this.$message({
                message: '更新失败',
                type: 'error'
              })
              this.formLoading = false;
            })
          } else {
            addbankcard({ ...this.formData }).then(res => {
              if (res.code == 1) {
                this.$message({
                  message: '新增成功',
                  type: 'success'
                })
                this.formLoading = false;
                this.addDialog = false;
                this.getbankcards();
              }
            }).catch((err) => {
              console.log(err)
              this.$message({
                message: '新增失败',
                type: 'error'
              })
              this.formLoading = false;
            })
          }
        }
      })
    },
    toUpperCase(type) {
      this.formData[type] = this.formData[type].toUpperCase();
    },
    openDialog(item) {
      this.systemVisaId = item.systemVisaId;
      this.dialogTableVisible = true;
    },
    addBankCard() {
      this.formData.systemVisaId = this.systemVisaId;
      this.addDialog = true;
    },
    handleDelete(item) {
      this.$confirm(`是否删除此张银行卡`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delbankcard({ id: item.id }).then(() => {
          this.$message({
            message: `删除成功`,
            type: 'success'
          });
          this.getbankcards();
        })
      })
    },
    handleEdit(item) {
      item.systemVisaId = this.systemVisaId;
      this.formData = JSON.parse(JSON.stringify(item));
      this.addDialog = true;
    },
    getbankcards() {
      querybankcards({ systemvisaId: 2 }).then(res => {
        this.bankCardList = res.data.rows;
      })
    },
    //立即办理
    toOrder(items, i, userId) {
      this.countryList[i].loading = true;
      orgorder({ systemVisaId: items.systemVisaId })
        .then((res) => {
          let item = res.data;
          this.countryList[i].loading = false;
          //马来西亚插件
          if (item.systemVisaId === 1) {
            this.$router.push({
              name: "malaysia",
              query: {
                id: item.id,
              },
            });
            return;
          }
          //其他国家的插件
          if (item && item.autocommit) {
            this.$router.push({
              name: "orderCenterElectron",
              params: {
                id: `${item.applicantName ? item.applicantName : 'name'}-${item.identityTypeName ? item.identityTypeName : 'type'}-${item.id}-${item.userId}-${item.systemVisaId}`,
              },
            });
          } else {
            this.$router.push({
              name: "informations",
              params: { id: `${item.id}` },
            });
          }
        })
        .catch((err) => {
          this.countryList[i].loading = false;
          console.log(err);
        });
    },
    //获取机构数据
    getordertool() {
      this.loading = true;
      let data = {
        Zone: (this.topFilterListActive == -1 || this.topFilterListActive == -100) ? '' : this.topFilterListActive,
        Key: this.searchContent,
      }
      getordertools(data).then((res) => {
        if (res.code == 1) {
          res.data.forEach((item) => {
            item.loading = false;
          });
          this.countryList = res.data;
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
      });
    },
    //是否收藏
    isCollected(item, i) {
      toolcollect({
        id: item.id,
        isCollected: !item.isCollected,
      }).then((res) => {
        if (this.topFilterListActive == -100) {
          this.isHandleCollet = false;
        } else {
          this.isHandleCollet = true;
        }
        this.countryList[i].isCollected = !this.countryList[i].isCollected;
        this.getordertool();
      });
    },
    toOrderCenter(id) {
      this.$router.push({
        name: "orderCenter",
        params: { id },
      });
    },
    openUrl(url) {
      window.open(url);
    },
  },
};
</script>
<style lang="scss" scoped>
.visa-wrapper {
  .visa-head {
    background: linear-gradient(to bottom, #e3f2fd 0%, #ffffff 100%);
    box-sizing: border-box;
    padding: 10px 20px;
    z-index: 999;

    .country_list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .country_item {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 10px;
        padding: 10px 20px;
        width: 6em;
        min-width: 6em;

        .country_item_img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: block;
          /* 核心多层阴影组合，模拟凸起质感 */
          box-shadow:
            /* 外阴影：模拟纽扣下方的投影 */
            0 4px 8px rgba(0, 0, 0, 0.25),
            /* 内高光：模拟纽扣左上边缘的反光 */
            inset 0 2px 3px rgba(255, 255, 255, 0.8),
            /* 内阴影：模拟纽扣右下边缘的暗部 */
            inset 0 -2px 3px rgba(0, 0, 0, 0.2);
          background: #f5f5f5;
          display: flex;
          align-items: center;
          justify-content: center;
          /* 禁止长按选中 */
          user-select: none;
          /* 取消点击高亮 */
          -webkit-tap-highlight-color: transparent;
          transition: all 0.2s ease;
        }
      }
    }

    .country_filter {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
      padding: 20px 20px 10px;
      background-color: #fff;
      border-radius: 8px;

      .country_filter_item {
        width: 4em;
        height: 35px;
        border-radius: 4px;
        padding: 0 15px;
        border: 1px solid #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        cursor: pointer;
        border-radius: 8px;
        background-color: #ffffff;

        &.active {
          border-color: #3888e9;
          background-color: #3888e910;
          color: #3888e9;
        }
      }
    }
  }

}

.wrap {
  width: 100%;
  // height: 100%;
  // height: calc(100% - 200px  - 58px);
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  // overflow: auto;
  box-sizing: border-box;
  padding: 0 16px 18px;

  /* 卡片之间的间距 */
  .box-card {
    /* min-width: 255px; */
    flex: 0 0 calc(25% - 35px);
    /* 每个卡片占25%宽度，减去间距的影响 */
    border: 1px solid #eee;
    max-width: 287px;
    height: 230px;
    box-sizing: content-box;
    padding: 12px 12px 0;
    /* margin-bottom: 20px;
    margin-right: 8px; */

    ::v-deep .el-card__body {
      padding: 0;
      transform: scale(0.95);
      transform-origin: left top;
    }

    .top {
      height: 34px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      justify-content: left;
      margin-bottom: 20px;

      .bgc {
        width: 55px;
        height: 36px;
      }

      p {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        margin-left: 12px;
      }
    }

    .center {
      height: 70px;
      display: flex;
      justify-content: left;
      flex-wrap: wrap;

      p {
        height: 22px;
        padding: 4px 12px;
        font-size: 13px;
        font-weight: 400;
        color: #666666;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        line-height: 22px;
        margin-bottom: 12px;
        margin-right: 10px;
        cursor: pointer;

        &:hover {
          color: #3888e9;
          border: 1px solid #3888e9;
        }
      }
    }

    .bottom {
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;

      .icon-box {
        width: 42px;
        height: 40px;

        .icon {
          width: 39px;
          height: 36px;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          text-align: center;
          line-height: 36px;
          cursor: pointer;

          img {
            width: 18px;
            height: 18px;
          }

          &:hover {
            border: none;
            box-shadow: 0px 0px 6px 1px rgba(56, 136, 233, 0.55);
          }
        }
      }

      .btn {
        width: 100px;
        height: 36px;
        font-size: 15px;
        border-radius: 4px;
        text-align: center;
        line-height: 36px;
        cursor: pointer;

        &:nth-child(2) {
          color: #3888e9;
          border: 1px solid #3888e9;
        }

        &:nth-child(3) {
          opacity: 1;
        }

        &:nth-child(2):hover {
          background-color: #3888e9;
          color: #ffffff;
        }

        &:nth-child(3):hover {
          opacity: 0.8;
        }

        ::v-deep .el-icon-loading {
          margin-left: -10px;
        }
      }
    }
  }
}

.common-dialog-class {
  .dialog-form-wrap {
    .info-form {
      el-form-item {
        width: 50%;
      }

      .radio-item {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;

        .radio-group {
          display: flex;
          flex-wrap: nowrap;

          .radio-group-item {
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-wrap: nowrap;
            padding: 20px 15px 20px 15px !important;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>
@/assets/js/visa.js